import { createFileRoute } from '@tanstack/react-router';

import { OrgSettingsPage } from '@/features/org/org-settings-page';

export const Route = createFileRoute('/_app/org/$orgId/settings')({
  component: OrgSettings,
});

function OrgSettings() {
  const { orgId } = Route.useParams();
  return <OrgSettingsPage orgId={orgId} />;
}
